import { render, staticRenderFns } from "./designPaint.vue?vue&type=template&id=b89a6066&scoped=true"
import script from "./designPaint.vue?vue&type=script&lang=js"
export * from "./designPaint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89a6066",
  null
  
)

export default component.exports